/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';

import {assertAndContinue} from 'Asserts';
import {Sequence} from 'components/Sequence';
import {Strand} from 'constants/MolbioConstants';
import {RegionSelectable} from 'molbio/maps/selectables/Selectables';
import * as sequtil from 'molbio/SeqUtil';
import * as mouse from 'util/Mouse';
import pick from 'util/pick';

interface AlignmentCommentProperties {
  layerStart: number | null;
  layerEnd: number | null;
  hover: boolean;
  selected: boolean;
  visible: boolean;
  start: number | null;
  end: number | null;
  text: string;
}

class AlignmentComment extends RegionSelectable<Sequence> {
  defaults(): AlignmentCommentProperties {
    return {
      layerStart: null,
      layerEnd: null,
      hover: false,
      selected: false,
      visible: true,
      start: null,
      end: null,
      text: '',
    };
  }

  layerStart(): number {
    assertAndContinue(this.get('layerStart') != null, 'Expected layerStart to exist');
    return this.get('layerStart');
  }
  layerEnd(): number {
    assertAndContinue(this.get('layerEnd') != null, 'Expected layerEnd to exist');
    return this.get('layerEnd');
  }

  drawStart(): number {
    return this.layerStart();
  }
  drawEnd(): number {
    return this.layerEnd();
  }

  uid(): string {
    return this.cid;
  }
  color(): string {
    return '#2980b9';
  }
  hover(): boolean {
    return this.get('hover');
  }
  selected(): boolean {
    return this.get('selected');
  }
  strand(): Strand {
    return 0;
  }

  click(e: Event, sequence: Sequence, shiftKey: boolean = false): void {
    if (e != null) {
      e.stopPropagation();
    }
    if (e && mouse.isRightClick(e as MouseEvent)) {
      return;
    }
    const selection = sequence.get('selection');
    selection.setEndpoints(this.start(), this.end());
    sequence.trigger('jump', this.start());
    this.trigger('open', this);
  }

  dblClick(e: Event, sequence: Sequence, shiftKey: boolean = false): void {
    this.click(e, sequence, shiftKey);
  }

  start(): number {
    return this.get('start');
  }
  end(): number {
    return this.get('end');
  }
  text(): string {
    return this.get('text');
  }
  toJSON(): object {
    return pick(super.toJSON(), 'start', 'end', 'text');
  }
  length(sequence: Sequence): number {
    return sequtil.length(this.start(), this.end(), sequence.length());
  }
}

class AlignmentComments extends Backbone.Collection<AlignmentComment> {
  analysisID!: number;

  static initClass(): void {
    this.prototype.model = AlignmentComment;
  }

  // @ts-expect-error: instance member property vs instance member function mismatch
  url(): string {
    return `/1/api/sequence/analyses/${this.analysisID}/alignment_comments`;
  }

  initialize(models: Array<AlignmentComment>, options: {analysisID: number}): void {
    this.analysisID = options.analysisID;
  }
}
AlignmentComments.initClass();

export {AlignmentComment, AlignmentComments};
